// @ts-check
// Regras do formulário de cadastro de instituição (contrato 08 de cobrança e operação, seção 7.2). Nome e sobrenome
// só são pedidos depois do envio do código do e-mail e só para conta nova: quem já tem conta (agências, redes) continua
// com o nome da conta e o Worker ignora o do formulário, então pedir antes obrigaria a preencher um campo descartado.

/**
 * @typedef {{ institutionName: string, slug: string, firstName: string, email: string }} SignUpFormFields
 * @typedef {{ isSlugValid: boolean, isCodeSent: boolean, isExistingAccount: boolean }} SignUpFormState
 */

/**
 * O nome aparece só quando a resposta do envio do código disse que o e-mail ainda não tem conta.
 * @param {Pick<SignUpFormState, 'isCodeSent' | 'isExistingAccount'>} state
 */
export const asksSignUpName = ({ isCodeSent, isExistingAccount }) => isCodeSent && !isExistingAccount;

/**
 * Enviar o código pede a instituição, um endereço válido e o e-mail; o nome ainda não.
 * @param {SignUpFormFields} form
 * @param {Pick<SignUpFormState, 'isSlugValid'>} state
 */
export const canSendSignUpCode = (form, { isSlugValid }) => Boolean(form.institutionName.trim() && form.slug && isSlugValid && form.email.trim());

/**
 * @param {SignUpFormFields} form
 * @param {SignUpFormState} state
 */
export const isSignUpNameMissing = (form, state) => asksSignUpName(state) && !form.firstName.trim();

/**
 * Criar a instituição pede o código enviado e, para conta nova, o nome.
 * @param {SignUpFormFields} form
 * @param {SignUpFormState} state
 */
export const canCreateInstitution = (form, state) => state.isCodeSent && canSendSignUpCode(form, state) && !isSignUpNameMissing(form, state);
